// extracted by mini-css-extract-plugin
export default {"container":"paymentOrderTicketsInfo_container__mflwY","ticketContainer":"paymentOrderTicketsInfo_ticketContainer__jtVtc"};